"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_button_1 = require("../button/awsui-button");
var ModalWrapper = /** @class */ (function (_super) {
    __extends(ModalWrapper, _super);
    function ModalWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalWrapper.prototype.findContent = function () {
        return this.find('[awsui-modal-region="content"]');
    };
    ModalWrapper.prototype.findHeader = function () {
        return this.find('[awsui-modal-region="header"]');
    };
    ModalWrapper.prototype.findFooter = function () {
        return this.find('[awsui-modal-region="footer"]');
    };
    ModalWrapper.prototype.findDismissButton = function () {
        var dismissButtonComponent = this.find('.awsui-modal-dismiss-control');
        if (!dismissButtonComponent) {
            return null;
        }
        return new awsui_button_1.default(dismissButtonComponent.getElement()).findNativeButton();
    };
    return ModalWrapper;
}(dom_1.ComponentWrapper));
exports.default = ModalWrapper;
//# sourceMappingURL=awsui-modal.js.map